export const Colors = ['#507DBC', '#F9A875',  '#EBC823',  '#9D83A7',  '#6DAFA0',  '#657383'];
export const DayPattern_PieChart = ['#C4C4C4', '#5EBCE5','#EBC823',  '#C7767A'];